import React, { useState } from "react";
import { Input, Row, Col, Select, Form } from "antd";
import { sellBoostFetch } from "../../utlifyFunction";
import { toast } from "react-toastify";
import CustomCard from "./CustomCard";
import PrimaryButton from "../Buttons/PrimaryButton";
const { TextArea } = Input;
const { Option } = Select;

export default function CustomInstructions({
	maxWords,
	setLoading,
	customPrompt,
	setCustomPrompt,
	existingDescription,
	title,
}) {
	const [selectedExample, setSelectedExample] = useState(null);

	const handleExampleChange = (value) => {
		const example = examplePrompts.find((ex) => ex.value === value);
		setSelectedExample(example.title);
		setCustomPrompt(value);
	};

	const handleEnhancePrompt = async () => {
		setLoading(true);
		try {
			const response = await sellBoostFetch("POST", "/AI/enhance-prompt", {
				customPrompt: customPrompt,
				title,
				existingDescription,
			});
			if (response?.prompt) {
				setCustomPrompt(response?.prompt);
				toast.success("Keywords generated successfully!");
			}
		} catch (error) {
			toast.error("Failed to generate keywords.");
		} finally {
			setLoading(false);
		}
	};

	return (
		<CustomCard>
			<Form layout="vertical">
				<Form.Item
					label="Enter your custom prompt:"
					extra={
						<div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
							<div>
								• Be specific about your requirements (e.g., "Write a 200-word
								product description")
							</div>
							<div>
								• Mention preferred format (bullet points, paragraphs, etc.)
							</div>
							<div>• Specify tone (professional, friendly, enthusiastic)</div>
							<div>
								• Include examples if you have specific phrasing preferences
							</div>
						</div>
					}
				>
					<TextArea
						autoSize={true}
						value={customPrompt}
						onChange={(e) => setCustomPrompt(e.target.value)}
						placeholder="Type your custom instructions here..."
						style={{ marginBottom: 16 }}
					/>
				</Form.Item>

				<Row gutter={16}>
					<Col span={12}>
						<Form.Item label="Select from example prompts:">
							<Select
								style={{ width: "100%", height: "40px" }}
								placeholder="Choose an example"
								onChange={handleExampleChange}
								value={selectedExample}
							>
								{examplePrompts.map((prompt, index) => (
									<Option key={index} value={prompt.value}>
										{prompt.title}
									</Option>
								))}
							</Select>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item label="Actions:">
							<PrimaryButton onClick={handleEnhancePrompt} width={"100%"}>
								Enhance Prompt
							</PrimaryButton>
						</Form.Item>
					</Col>
				</Row>
			</Form>
		</CustomCard>
	);
}

const examplePrompts = [
	{
		title: "Example 1: Product Description Generator",
		value: `Generate a concise, informative product description for the given product. The description should be 150–200 words and follow this layout:

Section: Intro
• Start with a brief paragraph that provides an overview of the product.

Section: List of Features
• Create an unordered list (<ul>) with at least 5 bullet points.
• Each bullet should outline a feature along with a short explanation.

Section: Final Thoughts
• Conclude with a paragraph summarizing the benefits and including a call-to-action.

Output the final content in clean, SEO-friendly HTML.`,
	},
	{
		title: "Example 2: Technical Documentation",
		value: `Create comprehensive technical documentation for the provided API endpoint. Include:

1. Overview:
   - Purpose of the API
   - Authentication method
   - Rate limits

2. Endpoint Details:
   - HTTP method
   - URL structure
   - Required headers
   - Query parameters

3. Request/Response Examples:
   - Sample request with all parameters
   - Success response (200) with schema
   - Error responses (4xx, 5xx)

4. Code Samples:
   - cURL example
   - JavaScript (fetch) example
   - Python (requests) example

Format the output in Markdown with proper headings and code blocks.`,
	},
	{
		title: "Example 3: Creative Writing Prompt",
		value: `Write a short story based on the following parameters:

Genre: [user specifies]
Setting: [user specifies]
Main Character: [user provides details]

Requirements:
1. Opening paragraph that establishes setting and mood
2. Introduction of main character with distinctive traits
3. Central conflict or challenge
4. Climax scene with tension
5. Resolution that provides closure

The story should be approximately 500 words with vivid descriptions and natural dialogue.`,
	},
];
